import type { UserMessageProps, UserMessageSlots, UserMessageState } from './UserMessage';
import {
  UserMessage,
  renderUserMessage_unstable,
  useUserMessageStyles_unstable,
  useUserMessage_unstable,
  userMessageClassNames,
} from './UserMessage';
import type { CopilotMessageProps, CopilotMessageSlots, CopilotMessageState } from './CopilotMessage';
import {
  CopilotMessage,
  copilotMessageClassNames,
  renderCopilotMessage_unstable,
  useCopilotMessageStyles_unstable,
  useCopilotMessage_unstable,
} from './CopilotMessage';

export type { CopilotChatProps, CopilotChatSlots, CopilotChatState } from './CopilotChat';
export {
  CopilotChat,
  copilotChatClassNames,
  renderCopilotChat_unstable,
  useCopilotChatStyles_unstable,
  useCopilotChat_unstable,
} from './CopilotChat';

export type { SystemMessageProps, SystemMessageSlots, SystemMessageState } from './SystemMessage';
export {
  SystemMessage,
  systemMessageClassNames,
  renderSystemMessage_unstable,
  useSystemMessageStyles_unstable,
  useSystemMessage_unstable,
} from './SystemMessage';

export type { AiGeneratedDisclaimerProps, AiGeneratedDisclaimerSlots } from './AiGeneratedDisclaimer';
export {
  AiGeneratedDisclaimer,
  aiGeneratedDisclaimerClassNames,
  useAiGeneratedDisclaimerStyles_unstable,
} from './AiGeneratedDisclaimer';

export { useMessageAttributes } from './utils/useMessageAttributes';
export { useScrollToBottom } from './utils/useScrollToBottom';

export type { TimestampProps, TimestampSlots, TimestampState } from './Timestamp';
export { Timestamp, timestampClassNames, useTimestampStyles_unstable } from './Timestamp';

/** @deprecated use CopilotMessageProps */
type CopilotMessageV2Props = CopilotMessageProps;
/** @deprecated use CopilotMessageSlots */
type CopilotMessageV2Slots = CopilotMessageSlots;
/** @deprecated use CopilotMessageState */
type CopilotMessageV2State = CopilotMessageState;

/** @deprecated use CopilotMessage */
const CopilotMessageV2 = CopilotMessage;
/** @deprecated use renderCopilotMessage_unstable */
const renderCopilotMessageV2_unstable = renderCopilotMessage_unstable;
/** @deprecated use useCopilotMessageStyles_unstable */
const useCopilotMessageV2Styles_unstable = useCopilotMessageStyles_unstable;
/** @deprecated use useCopilotMessage_unstable */
const useCopilotMessageV2_unstable = useCopilotMessage_unstable;
/** @deprecated use copilotMessageClassNames */
const copilotMessageV2ClassNames = copilotMessageClassNames;

export type {
  CopilotMessageProps,
  CopilotMessageV2Props,
  CopilotMessageSlots,
  CopilotMessageV2Slots,
  CopilotMessageState,
  CopilotMessageV2State,
};
export {
  CopilotMessage,
  CopilotMessageV2,
  renderCopilotMessage_unstable,
  renderCopilotMessageV2_unstable,
  useCopilotMessageStyles_unstable,
  useCopilotMessageV2Styles_unstable,
  useCopilotMessage_unstable,
  useCopilotMessageV2_unstable,
  copilotMessageClassNames,
  copilotMessageV2ClassNames,
};

/** @deprecated use UserMessageProps */
type UserMessageV2Props = UserMessageProps;
/** @deprecated use UserMessageSlots */
type UserMessageV2Slots = UserMessageSlots;
/** @deprecated use UserMessageState */
type UserMessageV2State = UserMessageState;

/** @deprecated use UserMessage */
const UserMessageV2 = UserMessage;
/** @deprecated use renderUserMessage_unstable */
const renderUserMessageV2_unstable = renderUserMessage_unstable;
/** @deprecated use useUserMessageStyles_unstable */
const useUserMessageV2Styles_unstable = useUserMessageStyles_unstable;
/** @deprecated use useUserMessage_unstable */
const useUserMessageV2_unstable = useUserMessage_unstable;
/** @deprecated use copilotMessageClassNames */
const userMessageV2ClassNames = userMessageClassNames;

export type {
  UserMessageProps,
  UserMessageV2Props,
  UserMessageSlots,
  UserMessageV2Slots,
  UserMessageState,
  UserMessageV2State,
};
export {
  UserMessage,
  UserMessageV2,
  renderUserMessage_unstable,
  renderUserMessageV2_unstable,
  useUserMessageStyles_unstable,
  useUserMessageV2Styles_unstable,
  useUserMessage_unstable,
  useUserMessageV2_unstable,
  userMessageClassNames,
  userMessageV2ClassNames,
};

export type { ScrollDownButtonProps, ScrollDownButtonSlots, ScrollDownButtonState } from './ScrollDownButton';
export {
  ScrollDownButton,
  renderScrollDownButton_unstable,
  scrollDownButtonClassNames,
  useScrollDownButtonStyles_unstable,
  useScrollDownButton_unstable,
} from './ScrollDownButton';
